import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=0588e3d3&"
import script from "./BaseButton.vue?vue&type=script&lang=js&"
export * from "./BaseButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=0588e3d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports